/**
 * Created by fd on 2021-09-20 (10:46).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/sell.html";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import InvestmentsView from "../components/investments-view";

require("Styles/components/views/sell.scss");

class SellView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.onSellProducts = options.onSellProducts;
        this._team = options.team;
        this.currentRoundData = options.currentRoundData;
        this.path = "sell";
        this.isSelling = false;
    }

    set team(team)
    {
        this._team = team;

        this.update();
    }

    render()
    {
        super.render();

        this.chipRow = this.$element.find("#resource-row-microchip");
        this.phoneRow = this.$element.find("#resource-row-phone");
        this.bikeRow = this.$element.find("#resource-row-bike");

        this._setUpEventListeners();

        this.onRender();

        this.update();
    }

    update()
    {
        if (this.isSelling)
        {
            this.isSelling = false;
            return;
        }

        if (!this.hasRendered)
        {
            return;
        }

        $(".sell-buttons").prop("disabled", false);

        if (this._team.currentRound >= 1)
        {
            $(".sell-skip-btn").show();
        }
        else
        {
            $(".sell-skip-btn").hide();
        }

        let hasPhoneFactory = InvestmentsView.hasPurchasedInvestment(this._team, { title: "phone_factory" });
        let hasBikeFactory = InvestmentsView.hasPurchasedInvestment(this._team, { title: "bike_factory" });

        this.setRowEnabled(this.chipRow, false);
        this.setRowEnabled(this.phoneRow, false);
        this.setRowEnabled(this.bikeRow, false);

        if (!hasBikeFactory && !hasPhoneFactory)
        {
            this.phoneRow.show();
            this.bikeRow.show();
        }
        else
        {
            this.phoneRow.hide();
            this.bikeRow.hide();

            if (hasPhoneFactory)
            {
                this.phoneRow.show();
                this.setRowEnabled(this.phoneRow, true);
            }
            else
            {
                this.bikeRow.show();
                this.setRowEnabled(this.bikeRow, true);
            }
        }

        this.setRowEnabled(this.chipRow, true);

        this.resetRow(this.chipRow);
        this.resetRow(this.phoneRow);
        this.resetRow(this.bikeRow);

        this.updateLabels();
    }

    setRowEnabled(row, enabled)
    {
        let totalWrapper = this.getTotalWrapper(row);

        row.removeClass("disabled");
        row.find("input").removeProp("disabled");
        row.find("counter-button").removeProp("disabled");
        totalWrapper.show();

        if (!enabled)
        {
            row.addClass("disabled");
            row.find("input").prop("disabled", "disabled");
            row.find("counter-button").prop("disabled", "disabled");
            totalWrapper.hide();
        }
    }

    getTotalWrapper(row)
    {
        return this.$element.find("#" + row.data("total-wrapper"));
    }

    _setUpEventListeners()
    {
        this.setRowEventListeners(this.chipRow);
        this.setRowEventListeners(this.phoneRow);
        this.setRowEventListeners(this.bikeRow);
    }

    resetRow(row)
    {
        row.find(".counter-input").val(0);
    }

    setRowEventListeners(row)
    {
        let input = row.find("input");
        let instance = this;
        let maxValue = 0;

        let sellBtn = this.$element.find(".sell-btn");
        let sellSkipBtn = this.$element.find(".sell-skip-btn");

        sellBtn.off("click").on("click", () =>
        {
            $(".sell-buttons").prop("disabled", "disabled");
            $("#btn-next-phase").prop("disabled", "disabled");

            this.isSelling = true;
            this.onSellProducts.call(this, this.getInfo());
        });

        sellSkipBtn.off("click").on("click", () =>
        {
            $(".sell-buttons").prop("disabled", "disabled");
            $("#btn-next-phase").prop("disabled", "disabled");

            this.onSellProducts.call(this, null);
        });

        row.find(".counter-increase").off("click").on("click", () =>
        {
            maxValue = parseInt(row.find(".max-resource-value").text());

            adjustCounter(1);
        });

        row.find(".counter-decrease").off("click").on("click", () =>
        {
            adjustCounter(-1);
        });

        row.find(".counter-input").off("focusout").on("focusout", () =>
        {
            adjustCounter(0);
        });

        function adjustCounter(delta)
        {
            let value = parseInt(input.val()) + delta;

            if (value < 0 || isNaN(value))
            {
                value = 0;
            }

            if (value > maxValue)
            {
                value = maxValue;
            }

            input.val(value);

            instance.updateLabels();
        }
    }

    updateLabels()
    {
        let info = this.getInfo();

        this.getTotalWrapper(this.chipRow).find("label").html(info.amount.chips + this.getMarketProductCount("microchip"));
        this.getTotalWrapper(this.phoneRow).find("label").html(info.amount.phones + this.getMarketProductCount("phone"));
        this.getTotalWrapper(this.bikeRow).find("label").html(info.amount.bikes + this.getMarketProductCount("bike"));

        $("[data-local-stock-resource-microchip]").text(this.currentRoundData.resourceMicrochip);
        $("[data-local-stock-resource-phone]").text(this.currentRoundData.resourcePhone);
        $("[data-local-stock-resource-bike]").text(this.currentRoundData.resourceBike);

        $("#resource-row-microchip .local-market-stock").text(this.currentRoundData.resourceMicrochip - info.amount.chips);
        $("#resource-row-phone .local-market-stock").text(this.currentRoundData.resourcePhone - info.amount.phones);
        $("#resource-row-bike .local-market-stock").text(this.currentRoundData.resourceBike - info.amount.bikes);

        let sellingAnything = info.amount.chips + info.amount.phones + info.amount.bikes > 0;
        $(".sell-btn").prop("disabled", sellingAnything ? false : "disabled");
        $(".sell-skip-btn").prop("disabled", sellingAnything ? "disabled" : false);

        this.$element.find("#sell-receive-label").html(info.total);
    }

    getInfo()
    {
        let info = {};
        let prices = { chips: 2, phones: 5, bikes: 7 };
        let chips = parseInt(this.chipRow.find("input").val());
        let phones = parseInt(this.phoneRow.find("input").val());
        let bikes = parseInt(this.bikeRow.find("input").val());

        info.prices = prices;
        info.amount = {};
        info.subtotal = {};

        info.amount.chips = chips;
        info.amount.phones = phones;
        info.amount.bikes = bikes;

        info.subtotal.chips = chips * prices.chips;
        info.subtotal.phones = phones * prices.phones;
        info.subtotal.bikes = bikes * prices.bikes;

        info.total = info.subtotal.chips + info.subtotal.phones + info.subtotal.bikes;

        return info;
    }

    getMarketProductCount(product)
    {
        let market = JSON.parse(this.currentRoundData.market);

        if (!market)
        {
            return 0;
        }

        switch (product)
        {
            case "microchip":
                return market.microchip || 0;
            case "phone":
                return market.phone || 0;
            case "bike":
                return market.bike || 0;
        }

        return 0;
    }
}

module.exports = SellView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/sell.js